module.exports = __webpack_public_path__ + "img/cedula_frontal.f819d016.jpg";